import { post } from './apiUtils';
import { UnsubscribeState } from '../store/Unsubscribe';

const baseUrl = '/api/v1/EmailSubscriptionInfo';

export function unsubscribe(data: UnsubscribeState): Promise<ApiResponse> {
  return post(`${baseUrl}/Unsubscribe`, {
    body: JSON.stringify(data),
  });
}

export function resubscribe(data: UnsubscribeState): Promise<ApiResponse> {
  return post(`${baseUrl}/Resubscribe`, {
    body: JSON.stringify(data),
  });
}

export default unsubscribe;
